/*
This file was generated by the Surface compiler.
*/

import debounce from "lodash.debounce"
import { blur, addScopedEventListener } from "../helpers"

export const select = {
  active: false,
  mounted() {
    this.el.addEventListener("focusin", () => this.toggleActive(true))
    this.el.addEventListener("focusout", (e) => {
      if (!e.relatedTarget || !this.el.contains(e.relatedTarget)) {
        this.toggleActive(false)
      }
    })
    this.el.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        e.stopImmediatePropagation()
        blur()
      }
    })
    addScopedEventListener(this.el, "click", "li", (e, choice) => {
      this.pushEventTo(this.el, "reset-options")
      this.select(choice)
      e.preventDefault()
    })
    // Note: using mousedown so it occurs before the `focusin` event
    this.el.querySelector(".select-icon").addEventListener("mousedown", (e) => {
      if (this.active) {
        blur()
        e.preventDefault()
      }
    })

    const textInput = this.el.querySelector('input[type="text"]')
    this.debouncedPushEvent = debounce(
      () => this.pushEventTo(this.el, "input", { value: textInput.value }),
      300,
    )
    textInput.addEventListener("input", (e) => {
      const hiddenValue = this.el.querySelector('input[type="hidden"]')

      if (hiddenValue) {
        hiddenValue.value = ""
      }

      e.stopImmediatePropagation()
      this.debouncedPushEvent()
    })
  },
  destroyed() {
    // Otherwise pushEventTo may be sent to the LiveView
    // See https://github.com/phoenixframework/phoenix_live_view/issues/4066
    this.debouncedPushEvent.cancel()
  },
  updated() {
    this.toggleActive(this.active)
  },
  toggleActive(active) {
    if (active) {
      const textInput = this.el.querySelector('input[type="text"]')
      textInput.focus()
    }

    this.active = active
    this.el.querySelector(".select").classList.toggle("select-active", active)
  },
  select(li) {
    const textInput = this.el.querySelector('input[type="text"]')
    // Surface element uses a select tag for the hidden value (not sure why)
    // Heex element uses a hidden input
    const hiddenValue = this.el.querySelector('select, input[type="hidden"]')

    textInput.value = li.innerText
    hiddenValue.value = li.dataset.value

    window.setTimeout(() => {
      hiddenValue.dispatchEvent(new Event("input", { bubbles: true }))
    })
    blur()
  },
}
